import React from "react";

import Dashboard from "../../client_config/ppc_config/all/dashboard/Dashboard";

export default function All(props) {
  return (
    <div style={{ backgroundColor: "#F5F5F5" }}>
      <Dashboard {...props} onboarding />
    </div>
  );
}
